/* eslint-disable jsx-a11y/no-static-element-interactions */

import PropTypes from 'prop-types';
import React from 'react';
import SIStyles from './SIStyles.scss';

const StoresInput = ({
  storeNumber, storeName, removeStoreZips, addStoreZips,
}) => (<div className={SIStyles.tag}>
  <div>{storeNumber !== null ? `${storeName} -` : `${storeName}`}</div>
  <div className={SIStyles.storeNumber}>{storeNumber}</div>
  <div className={SIStyles.add} onClick={() => addStoreZips(storeName)}>
    <div>Add Back</div>
    <div>&#43;</div>
  </div>
  <div className={SIStyles.remove} onClick={() => removeStoreZips(storeName)}>
    <div>Remove</div>
    <div>&#45;</div>
  </div>
</div>);

StoresInput.propTypes = {
  storeNumber: PropTypes.string,
  storeName: PropTypes.string,
  removeStoreZips: PropTypes.func,
  addStoreZips: PropTypes.func,
};

StoresInput.defaultProps = {
  storeNumber: '',
  storeName: '',
};

export default StoresInput;




// WEBPACK FOOTER //
// ./client/app/shared/components/TaggedInput/CustomTaggedInput/StoresInput/SIIndex.jsx